@if (card) {
    <mat-card>
        <ng-container *ngTemplateOutlet="page"></ng-container>
    </mat-card>
} @else {
    @if (showHeader) {
        <div class="header">
            <div class="text-center">
                <img [alt]="companyName + ' Logo'" [src]="companyImg" class="w-25 mx-auto logoBg">
            </div>
            @if (!community?.profile_survey_intro_text_rendered) {
                <div class="text-center">
                    <h3>Please update your profile</h3>
                </div>
            }
        </div>
    }
    @if (community) {
        <div class="content">
            @if (community.profile_survey_intro_text_rendered) {
                <div class="d-flex w-100">
                    <div [innerHTML]="community.profile_survey_intro_text_rendered">
                    </div>
                </div>
            }
            <form [formGroup]="profileForm" class="mt-10 flex-col mb-10">
                @for (field of dynamicFormFields; track field) {
                    @if (field.question_type) {
                        @if (!field.hidden && field.question_type) {
                            <div class="flex-col mt-5">
                                @if (!field.text_rendered) {
                                    <p class="labelTitle">{{ field.text }}</p>
                                }
                                @if (!field.help_text_rendered) {
                                    <p class="labelSubtitle">{{ field.help_text }}</p>
                                }
                                @if (field.text_rendered) {
                                    <div [innerHTML]="field.text_rendered"
                                         class="ck-editorControl"></div>
                                }
                                @if (field.help_text_rendered) {
                                    <div [innerHTML]="field.help_text_rendered"
                                         class="ck-editorControl"></div>
                                }
                                @if (field.image) {
                                    <div>
                                        <img [src]="field.image" class="max-w-100">
                                    </div>
                                }
                                @if (field.question_type === 'multiple_choice') {
                                    <div class="flex-col gap-15">
                                        @for (option of field.options; track option; let i = $index) {
                                            <div
                                                    class="flex-row align-items-center gap-15">
                                                <button (click)="fieldSelect(field, option)"
                                                        [color]="profileForm.get(field.id.toString())?.value?.includes(option.id)? 'primary' :null"
                                                        class="customFab"
                                                        mat-mini-fab>
                                                    @if (profileForm.get(field.id.toString())?.value?.includes(option.id)) {
                                                        <mat-icon
                                                        >
                                                            check
                                                        </mat-icon>
                                                    }
                                                </button>
                                                {{ option.text }}
                                            </div>
                                        }
                                    </div>
                                    @if (profileForm.controls[field.id].hasError('required')) {
                                        <small class="errorMsg">
                                            This field is required
                                        </small>
                                    }
                                }
                                @if (field.question_type === 'single_choice') {
                                    <mat-radio-group [formControlName]="field.id"
                                                     class="flex-col">
                                        @for (option of field.options; track option) {
                                            <mat-radio-button [value]="option.id"
                                                              class="example-radio-button">{{ option.text }}
                                            </mat-radio-button>
                                        }
                                    </mat-radio-group>
                                    @if (profileForm.controls[field.id].hasError('required')) {
                                        <small class="errorMsg">
                                            This field is required
                                        </small>
                                    }
                                }
                                @if (field.question_type !== 'date' && field.question_type !== 'single_choice' && field.question_type !== 'multiple_choice') {
                                    <mat-form-field [class.noBottomPadding]="getControl(field.id)?.valid"
                                                    appearance="outline" class="w-100"
                                                    color="accent">
                                        <mat-label></mat-label>
                                        @if (field.question_type == 'dropdown') {
                                            <mat-select [formControlName]="field.id"
                                                        [multiple]="field.dropdown_allows_multiple_selection">
                                                @for (option of field.options; track option) {
                                                    <mat-option
                                                            [value]="option.id"
                                                            (onSelectionChange)="field.dropdown_allows_multiple_selection ? fieldSelect(field, option) : null">
                                                        {{ option.text }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        }
                                        @if (field.question_type == 'text') {
                                            <input [formControlName]="field.id" matInput type="text">
                                        }
                                        @if (field.question_type == 'numeric') {
                                            <input [formControlName]="field.id" matInput type="number">
                                        }
                                        @if (profileForm.controls[field.id].hasError('required')) {
                                            <mat-error>
                                                This field is required
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                }
                                @if (field.question_type === 'date') {
                                    <mat-form-field [class.noBottomPadding]="getControl(field.id)?.valid"
                                                    appearance="outline"
                                                    class="w-100">
                                        <mat-label></mat-label>
                                        <input #dateInput (dateChange)="checkIfCorrectAge(field, $event.value)"
                                               [formControlName]="field.id" [matDatepicker]="picker"
                                               [max]="field.is_dob? today : null"
                                               matInput>
                                        <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        @if (profileForm.controls[field.id].hasError('required')) {
                                            <mat-error>
                                                This field is required
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    @if (field.incorrectAge && dateInput.value) {
                                        <small class="errorMsg">
                                            Minimum years {{ field.minimum_number_of_years }}
                                        </small>
                                    }
                                }
                            </div>
                        }
                    }
                    @if (!field.question_type) {
                        <div class="flex-col mt-5">
                            @if (!field.text_rendered) {
                                <p class="labelTitle">{{ field.text }}</p>
                            }
                            @if (field.text_rendered) {
                                <div [innerHTML]="field.text_rendered"
                                     class="ck-editorControl"></div>
                            }
                        </div>
                    }
                }
            </form>
            <div class="w-100 text-center mt-20" (mouseenter)="validateForm(profileForm)">
                @if (isRegistrationPage) {
                    <button (click)="submit()"
                            [disabled]="loading || profileForm.invalid || !allAgesCorrect()"
                            class="mx-auto"
                            color="accent" mat-flat-button>
                        Next
                        @if (loading) {
                            <mat-icon>
                                <mat-spinner color="accent"></mat-spinner>
                            </mat-icon>
                        }
                    </button>
                }
                @if (!isRegistrationPage) {
                    <button (click)="update()"
                            [disabled]="loading || profileForm.invalid|| !allAgesCorrect()"
                            class="mx-auto"
                            color="primary" mat-raised-button>
                        Update Profile
                        @if (loading) {
                            <mat-icon>
                                <mat-spinner color="accent"></mat-spinner>
                            </mat-icon>
                        }
                    </button>
                }
            </div>
        </div>
    }
}

<ng-template #page>
    @if (showHeader) {
        <div class="header">
            <div class="text-center">
                <img [alt]="companyName + ' Logo'" [src]="companyImg" class="w-25 mx-auto logoBg">
            </div>
            @if (!community?.profile_survey_intro_text_rendered) {
                <div class="text-center">
                    <h3>Please update your profile</h3>
                </div>
            }
        </div>
    }
    @if (community) {
        <div class="content">
            @if (community.profile_survey_intro_text_rendered) {
                <div class="d-flex w-100">
                    <div [innerHTML]="community.profile_survey_intro_text_rendered">
                    </div>
                </div>
            }
            <form [formGroup]="profileForm" class="mt-10 flex-col mb-10">
                @for (field of dynamicFormFields; track field) {
                    @if (field.question_type) {
                        @if (!field.hidden && field.question_type) {
                            <div class="flex-col mt-5">
                                @if (!field.text_rendered) {
                                    <p class="labelTitle">{{ field.text }}</p>
                                }
                                @if (!field.help_text_rendered) {
                                    <p class="labelSubtitle">{{ field.help_text }}</p>
                                }
                                @if (field.text_rendered) {
                                    <div [innerHTML]="field.text_rendered"
                                         class="ck-editorControl"></div>
                                }
                                @if (field.help_text_rendered) {
                                    <div [innerHTML]="field.help_text_rendered"
                                         class="ck-editorControl"></div>
                                }
                                @if (field.image) {
                                    <div>
                                        <img [src]="field.image" class="max-w-100">
                                    </div>
                                }
                                @if (field.question_type === 'multiple_choice') {
                                    <div class="flex-col gap-15">
                                        @for (option of field.options; track option; let i = $index) {
                                            <div
                                                    class="flex-row align-items-center gap-15">
                                                <button (click)="fieldSelect(field, option)"
                                                        [color]="profileForm.get(field.id.toString())?.value?.includes(option.id)? 'primary' :null"
                                                        class="customFab"
                                                        mat-mini-fab>
                                                    @if (profileForm.get(field.id.toString())?.value?.includes(option.id)) {
                                                        <mat-icon
                                                        >
                                                            check
                                                        </mat-icon>
                                                    }
                                                </button>
                                                {{ option.text }}
                                            </div>
                                        }
                                    </div>
                                    @if (profileForm.controls[field.id].hasError('required')) {
                                        <small class="errorMsg">
                                            This field is required
                                        </small>
                                    }
                                }
                                @if (field.question_type === 'single_choice') {
                                    <mat-radio-group [formControlName]="field.id"
                                                     class="flex-col">
                                        @for (option of field.options; track option) {
                                            <mat-radio-button [value]="option.id"
                                                              class="example-radio-button">{{ option.text }}
                                            </mat-radio-button>
                                        }
                                    </mat-radio-group>
                                    @if (profileForm.controls[field.id].hasError('required')) {
                                        <small class="errorMsg">
                                            This field is required
                                        </small>
                                    }
                                }
                                @if (field.question_type !== 'date' && field.question_type !== 'single_choice' && field.question_type !== 'multiple_choice') {
                                    <mat-form-field [class.noBottomPadding]="getControl(field.id)?.valid"
                                                    appearance="outline" class="w-100"
                                                    color="accent">
                                        <mat-label></mat-label>
                                        @if (field.question_type == 'dropdown') {
                                            <mat-select [formControlName]="field.id"
                                                        [multiple]="field.dropdown_allows_multiple_selection">
                                                @for (option of field.options; track option) {
                                                    <mat-option
                                                            [value]="option.id"
                                                            (onSelectionChange)="field.dropdown_allows_multiple_selection ? fieldSelect(field, option) : null">
                                                        {{ option.text }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        }
                                        @if (field.question_type == 'text') {
                                            <input [formControlName]="field.id" matInput type="text">
                                        }
                                        @if (field.question_type == 'numeric') {
                                            <input [formControlName]="field.id" matInput type="number">
                                        }
                                        @if (profileForm.controls[field.id].hasError('required')) {
                                            <mat-error>
                                                This field is required
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                }
                                @if (field.question_type === 'date') {
                                    <mat-form-field [class.noBottomPadding]="getControl(field.id)?.valid"
                                                    appearance="outline"
                                                    class="w-100">
                                        <mat-label></mat-label>
                                        <input #dateInput (dateChange)="checkIfCorrectAge(field, $event.value)"
                                               [formControlName]="field.id" [matDatepicker]="picker"
                                               [max]="field.is_dob? today : null"
                                               matInput>
                                        <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        @if (profileForm.controls[field.id].hasError('required')) {
                                            <mat-error>
                                                This field is required
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    @if (field.incorrectAge && dateInput.value) {
                                        <small class="errorMsg">
                                            Minimum years {{ field.minimum_number_of_years }}
                                        </small>
                                    }
                                }
                            </div>
                        }
                    }
                    @if (!field.question_type) {
                        <div class="flex-col mt-5">
                            @if (!field.text_rendered) {
                                <p class="labelTitle">{{ field.text }}</p>
                            }
                            @if (field.text_rendered) {
                                <div [innerHTML]="field.text_rendered"
                                     class="ck-editorControl"></div>
                            }
                        </div>
                    }
                }
            </form>
            <div class="w-100 text-center mt-20" (mouseenter)="validateForm(profileForm)">
                @if (isRegistrationPage) {
                    <button (click)="submit()"
                            [disabled]="loading || profileForm.invalid || !allAgesCorrect()"
                            class="mx-auto"
                            color="accent" mat-flat-button>
                        Next
                        @if (loading) {
                            <mat-icon>
                                <mat-spinner color="accent"></mat-spinner>
                            </mat-icon>
                        }
                    </button>
                }
                @if (!isRegistrationPage) {
                    <button (click)="update()"
                            [disabled]="loading || profileForm.invalid|| !allAgesCorrect()"
                            class="mx-auto"
                            color="primary" mat-raised-button>
                        Update Profile
                        @if (loading) {
                            <mat-icon>
                                <mat-spinner color="accent"></mat-spinner>
                            </mat-icon>
                        }
                    </button>
                }
            </div>
        </div>
    }

</ng-template>
